import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/(lang)/blogs/components/BlogsLayout.jsx");
